const platformRouters = [
  {
    path:"/institution",
    name:"institution",
    // meta:{
    //   keepAlive:true
    // },
    component:()=> import("@/views/platform/institution/index")
  },{
    path:"/institutionDetail",
    name:"institutionDetail",
    component:()=> import("@/views/platform/institution/institutionDetail")
  },{
    path:"/newInstitution",
    name:"newInstitution",
    component:()=> import("@/views/platform/institution/newInstitution")
  },{
    path:"/merchant",
    name:"merchant",
    // meta:{
    //   keepAlive:true
    // },
    component:()=> import("@/views/platform/merchant/index")
  }
]
export default platformRouters